import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { Container, Fade, Box } from "@mui/material";
import ManageLocationPage from "./ManageLocationPage";
import AppBar from "../components/AppBar";
import { ViewSentiment } from "../SentimentPages/ViewSentiment";
import { SessionsPage } from "../SessionPages/SessionsPage";
import { ViewAnswersPage } from "../AnswerPages/ViewAnswersPage";
import { useLocation } from "../../context/LocationContext";
import { useEffect } from "react";
import { LocationDataType } from "../../context/LocationContext/LocationProvider";
import { ManageLocationStudentPage } from "./ManageLocationStudentsPage";
import { ManageLocationStaffPage } from "./ManageLocationStaffPage";
const LocationPageRoutes = () => {
    const navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }
    const { id } = useParams()
    const { fetchLocation, location } = useLocation()
    useEffect(() => {
        if (!id) return;
        fetchLocation(id!)
    }, [id])
    return (
        <Routes>
            <Route path="/" element={<ManageLocationPage onBack={goBack} />} />
            <Route path="/manage/*" element={<LocationManageRoutes goBack={goBack} location={location} />} />
            <Route path="/sentiment" element={<ViewSentiment onBack={goBack} />} />
            <Route path="/sessions" element={<SessionsPage onBack={goBack} />} />
            <Route path="/answers" element={<ViewAnswersPage onBack={goBack} />} />
        </Routes>
    )
}
const LocationManageRoutes = ({ goBack, location }: { goBack: () => void, location: LocationDataType }) => {
    const navigate = useNavigate()
    const handleSelectedPerson = (id: string, action: string) => {
        switch (action) {
            case "Profile":
                navigate(`/staff/manage/${id}`);
                break;
            case "Link":
                navigate(`/staff/manage/link/${id}`)
                break;

        }
    }


    return (
        <Routes>
            <Route path="/students" element={<ManageLocationStudentPage onBack={goBack} />} />
            <Route path="/staff" element={<ManageLocationStaffPage onBack={goBack} onSelectedPerson={handleSelectedPerson} location={location} />} />
        </Routes>
    )
}
export const LocationRoutes = () => {

    return (
        <Fade in={true} timeout={500}>
            <Box component="div">
                <AppBar />
                <Container maxWidth="xl">
                    <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                        <Routes>
                            <Route path="/:id/*" element={<LocationPageRoutes />} />
                        </Routes>
                        {/* <LocationPageRoutes /> */}
                    </Box>
                </Container>
            </Box>
        </Fade>
    )
}

